import {
  GET_SELL_FROM_HOME_HISTORY_SUCCESS,
  GET_SELL_FROM_HOME_HISTORY_ERROR,
  GET_SELL_FROM_HOME_HISTORY_EMPTY,
} from '../../actions/orders/orderActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  data: [],
  error: '',
};

export default createReducer(
  {
    [GET_SELL_FROM_HOME_HISTORY_SUCCESS]: setSellFromHomeHistory,
    [GET_SELL_FROM_HOME_HISTORY_ERROR]: setSellFromHomeHistoryError,
    [GET_SELL_FROM_HOME_HISTORY_EMPTY]: resetSellFromHomeHistory,
  },
  initialState,
);

function setSellFromHomeHistory(state, action) {
  return {
    ...state,
    data: action.payload,
    error: '',
  };
}

function setSellFromHomeHistoryError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function resetSellFromHomeHistory() {
  return initialState;
}
